<template lang="pug">
  .pane.user-check(:class="objectClass")
    .pane__header Подтверждение данных

    .pane__body

      .user-check__container

        .user-check__input-wrapper
          label.user-check__label(@click="") Телефон:
          PhoneMaskInput.user-check__phone-input(
            inputClass="user-check__input"
            flagClass="user-check__flag"
            v-model="phoneValue"
            autoDetectCountry
            showFlag
            defaultCountry="by"
            @onValidate="onPhoneValidate"
            ref="phoneInputComponent"
          )

          button.button.button--primary.user-check__button(
            @click="onRequestButton"
            :disabled="isRequestButtonDisabled"
          )
            template(v-if="isRequestButtonLocked && timerValue") {{this.timerValue}}
            template(v-else) Запросить код проверки

        .user-check__input-wrapper(v-show="isCheckFormVisible")
          label.user-check__label(for="code") Код из SMS:
          input.user-check__input.user-check__input--code(
            v-model="codeValue"
            id="code"
            maxlength="10"
            ref="codeInput"
          )

          button.button.button--primary.user-check__button(
            @click="onCheckButton"
            :disabled="isCheckButtonDisabled"
            :class="{'is-checking': isChecking}"
          )
            span Проверить код
            template(v-if="isChecking")
              .spinner.user-check__spinner


      .user-check__container(v-if="isVerified || isError")
        span.success-text(v-if="isVerified") Код подтвержден
        span.error-text(v-else-if="isError") {{errorText}}

      .user-check__container
        label.user-check__checkbox-wrapper(:class="{'success-text': isOfferAccepted}")
          input.user-check__checkbox(
            type='checkbox'
            @change="setOfferState($event.target.checked)"
          )
          span Согласен с &nbsp;
          a.user-check__offer-link(href="#") условиями оказания услуг

</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import PhoneMaskInput from "vue-phone-mask-input";

export default {
  name: 'UserCheck',
  components: {PhoneMaskInput},
  data() {
    return {
      phoneValue: '',
      codeValue: '',

      intervalTimerId: 0,             // id таймера
      timeoutId: 0,                   // id таймаута
      timerValue: 0,                  // значение таймера
      timerSec: 10,                   // длительность таймера (sec)
      isPhoneValid: false,            // валидность введенного телефона
      isRequestButtonLocked: false,   // блок. кнопки запроса кода
      isCheckButtonLocked: true,      // блок. кнопки проверки кода
      isChecking: false,              // идет процесс проверки кода
    }
  },
  computed: {
    ...mapGetters('places', {isPlacesValid: 'isValid'}),
    ...mapGetters('payment', {isPaymentValid: 'isValid'}),
    ...mapGetters('user', {
      isVerified: 'getVerificationState',
      isError: 'getErrorState',
      errorText: 'getErrorText',
      isOfferAccepted: 'getOfferState',
    }),
    objectClass() {
      return {
        'pane--closed': !this.isPlacesValid || !this.isPaymentValid,
      }
    },
    isRequestButtonDisabled() {
      return this.isRequestButtonLocked || !this.isPhoneValid;
    },
    isCheckFormVisible() {
      return !this.isCheckButtonLocked;
    },
    isCheckButtonDisabled() {
      return !this.codeValue.length;
    },
  },
  watch: {
    isUserCheckOpened(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          const phoneInput = this.$refs.phoneInputComponent.$el.querySelector('input');
          phoneInput?.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
          setTimeout(() => {
            phoneInput?.focus();
          }, 300)
        });
      }
    },
    isCheckFormVisible(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.codeInput.focus();
        });
      }
    },
  },
  methods: {
    ...mapActions('user', {
      requestCode: 'requestCode',
      checkCode: 'checkCode',
    }),
    ...mapMutations('user', {
      setOfferState: 'setOfferState'
    }),
    onPhoneValidate(value) {
      this.isPhoneValid = value.isValidByLibPhoneNumberJs;
    },
    setTimer() {
      this.isRequestButtonLocked = true;
      this.timerValue = this.timerSec;
      this.intervalTimerId = setInterval(() => this.timerValue--, 1000);
      this.timeoutId = setTimeout(() => {
        this.isRequestButtonLocked = false;
        clearInterval(this.intervalTimerId);
      }, this.timerSec * 1000);
    },
    async onRequestButton() {
      this.setTimer();
      const ok = await this.requestCode({
        phone: this.phoneValue
      });
      this.isCheckButtonLocked = false;
      if (!ok) {
        this.isCheckButtonLocked = true;
        this.resetTimers();
      }
    },
    async onCheckButton() {
      this.isChecking = true;
      await this.checkCode({
        phone: this.phoneValue,
        code: this.codeValue
      });
      this.isChecking = false;
    },
    resetTimers() {
      clearInterval(this.intervalTimerId);
      clearTimeout(this.timeoutId);
      this.isRequestButtonLocked = false;
    }
  }
}
</script>



